import { ROLES } from 'app/developer-v3/constants';

export const tooltipsContent = {
  [ROLES.admin]: 'User has full access to manage this Zapier integration.',
  [ROLES.collaborator]: 'User has read-only access to this Zapier integration.',
  [ROLES.subscriber]:
    'User will only receive email updates about this Zapier integration.',
};
